import { Badge } from '@shared/components/ui/badge';
import { useTranslation } from 'react-i18next';

interface RateStatusBadgeProps {
  isActive: boolean;
}

export const RateStatusBadge = ({ isActive }: RateStatusBadgeProps) => {
  const { t } = useTranslation('ratesModule');

  if (isActive) {
    return (
      <Badge className="text-xs bg-bg-success text-success">
        {t('status.active')}
      </Badge>
    );
  }

  return (
    <Badge className="text-xs bg-card-border text-text">
      {t('status.inactive')}
    </Badge>
  );
};
